import { Injectable } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs'


@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor() {
    datadogLogs.init({
      clientToken: '<DATADOG_CLIENT_TOKEN>',
      site: '<DATADOG_SITE>',
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
    })
    
  }

  log(message: string): void {
    const logMessage = `[INFO] ${message}`;
    console.info(logMessage);
    datadogLogs.logger.info(logMessage)
  }

  warn(message: string): void {
    const logMessage = `[WARNING] ${message}`;
    console.info(logMessage);
    datadogLogs.logger.warn(message);
  }

  error(message: string): void {
    const logMessage = `[ERROR] ${message}`;
    console.info(logMessage);
    datadogLogs.logger.error(logMessage);
  }
}
